// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1nIog","rootNoMargin":"styles_rootNoMargin__3gyJS"};